import { type GetAdditionalProgressionFlowsAvailableForJobResponse } from '@taxfyle/api-internal/internal/job_progression_pb'
import { type Id } from '@/infra/id'
import {
  type AvailableInventoryItemTaxExtensionFlows,
  type AvailableJobProgressionFlowsProps,
} from './AvailableJobProgressionFlows'

export function mapAvailableJobProgressionFlowsResponseProtoToProps(
  proto: GetAdditionalProgressionFlowsAvailableForJobResponse,
  jobId: Id,
): AvailableJobProgressionFlowsProps {
  const taxExtension = proto.getInventoryItem()?.getTaxExtension()
  return {
    jobId,
    availableInventoryItemTaxExtensionFlows: taxExtension
      ? mapTaxExtensionProtoToAvailableFlows(taxExtension)
      : null,
  }
}

function mapTaxExtensionProtoToAvailableFlows(
  proto: GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension,
): AvailableInventoryItemTaxExtensionFlows {
  return {
    personalExtensionProgressionFlowAvailable:
      proto.getPersonalExtensionProgressionFlowAvailable(),
    businessExtensionProgressionFlowAvailable:
      proto.getBusinessExtensionProgressionFlowAvailable(),
    outsourcingExtensionProgressionFlowAvailable:
      proto.getOutsourcingExtensionProgressionFlowAvailable(),
  }
}
